import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Navbar() {
  const loc = useLocation();
  const onDark = loc.pathname === "/platform";
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const base = onDark
    ? "bg-[#0B172A]/80 border-b border-white/10 text-cream"
    : scrolled
    ? "bg-cream/85 border-b border-[#0B172A]/10 text-navy"
    : "bg-transparent border-b border-transparent text-navy";

  return (
    <nav
      data-testid="primary-navbar"
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl transition-colors ${base}`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
          <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden>
            <circle cx="14" cy="14" r="13" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="14" cy="14" r="4" fill="#D95D39" />
            <circle cx="14" cy="4" r="2" fill="#4C956C" />
            <circle cx="24" cy="18" r="2" fill="#0077B6" />
            <circle cx="4" cy="18" r="2" fill="#D95D39" />
            <line x1="14" y1="14" x2="14" y2="4" stroke="currentColor" strokeWidth="0.8" opacity="0.5" />
            <line x1="14" y1="14" x2="24" y2="18" stroke="currentColor" strokeWidth="0.8" opacity="0.5" />
            <line x1="14" y1="14" x2="4" y2="18" stroke="currentColor" strokeWidth="0.8" opacity="0.5" />
          </svg>
          <div className="leading-none">
            <div className="font-serif-display text-xl tracking-tight">UNNATI</div>
            <div className="font-mono-data text-[10px] uppercase tracking-[0.22em] opacity-70">DPI · Capacity Building</div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#vision" data-testid="nav-vision" className="hover:text-terracotta">Vision</a>
          <a href="/#loop" data-testid="nav-engine" className="hover:text-terracotta">Learning Engine</a>
          <a href="/#shift" data-testid="nav-shift" className="hover:text-terracotta">Paradigm Shift</a>
          <a href="/#maturity" data-testid="nav-maturity" className="hover:text-terracotta">Roadmap</a>
        </div>

        <Link
          to="/platform"
          data-testid="nav-platform-cta"
          className="group inline-flex items-center gap-2 px-4 py-2 bg-terracotta text-white font-medium text-sm hover:bg-[#c44e2e]"
        >
          Launch Platform
          <span className="group-hover:translate-x-0.5 transition-transform">→</span>
        </Link>
      </div>
    </nav>
  );
}
